

export class EventsTranslationConstants {

    static readonly ADD_EVENT_HASHTAG:'BP_EM_AEH'
    static readonly BEST_RACES:'BP_EM_BEST_RACES'
    static readonly BACK_TO_EVENT:'BP_EM_BTE'
    static readonly CROP_COVER_IMAGE:'BP_EM_CROP_COVERIMG'
    static readonly DELETE_IMAGE:'BP_EM_DELETE_IMAGE'
    static readonly DOWNLOAD:'BP_EM_DOWNLOAD'

    static readonly DOWNLOAD_ALL: 'BP_EM_DOWNLOAD_ALL'
    static readonly DOWNLOAD_ADMIN_QR:'BP_EM_DOWNLOADADM_QR'
    static readonly DOWNLOAD_EMPTY_EXCEL:'BP_EM_DOWNLOADEMP_EXCEL'
    static readonly DOWNLOAD_EXCEL_TEMP:'BP_EM_DOWNLOAD_EXCEL_TEMP'
    static readonly DOWNLOAD_QR :'BP_EM_DOWNLOAD_QR'

    static readonly INCOMING_RACES:'BP_EM_INCOMING_RACES'
    static readonly MANAGE_INCOMING_RACES:'BP_EM_MANAGE_INCOMING_RACES'
    static readonly MANUALLY_ADD_PARTICIPANTS:'BP_EM_MANUALLY_ADD_PART'
    static readonly OPERATOR_EMAIL:'BP_EM_OPERATOR_EMAIL'
    static readonly OPERATOR_NAME:'BP_EM_OPERATOR_NAME'
    static readonly OPERATOR_NUMBER:'BP_EM_OPERATOR_PH'
    static readonly OR:'BP_EM_OR'
    static readonly RANK:'BP_EM_RANK'
    static readonly RACER_NAME:'BP_EM_RACER_NAME'
    static readonly RENAME_EXERCISE:'BP_EM_RENAME_EXERCISE'
    static readonly STATUS:'BP_EM_STATUS'
    static readonly SELECT_EVENT_EXERCISES:'BP_EM_SELECT_EVENT_EXERCISES'
    static readonly TIME_CLOCKED:'BP_EM_TIME_CLOCKED'
    static readonly QR_CODES:'BP_EM_QR_CODES'
    static readonly UPLOAD_PARTICIPANTS:'BP_EM_UPLOAD_PARTICIPANTS'
    static readonly UPLOAD_PART_LIST:'BP_EM_UPLOAD_PART_LIST'
    static readonly ALL_EVENTS:'BP_EM_ALL_EVENTS'
    static readonly EMAILER_FAILED:'BP_EM_EMAIL_FAIL'
    static readonly EMAILER_HOLD:'BP_EM_EMAIL_HOLD'
    static readonly EMAILER_SENT:'BP_EM_EMAIL_SENT'
    static readonly FAILED:'BP_EM_FAILED'
    static readonly MANAGE_BR_BD:'BP_EM_MANAGE_BR_BD'
    static readonly IN_PROGRESS:'BP_EM_BR_IP'
    static readonly RACE_DATA_UPLOADED:'BP_EM_RACE_DATA_UPLOAD'
    static readonly RACE_DATA_UPLOAD_FAIL:'BP_EM_RACE_DATA_UPLOAD_FAIL'
    static readonly RACE_DATA_UPLOAD_HOLD:'BP_EM_RACE_DATA_UPLOAD_HOLD'
    static readonly RACE_VIDEO_UPLOADED:'BP_EM_RACE_VIDEO_UPLOAD'
    static readonly RACE_VIDEO_UPLOAD_FAIL:'BP_EM_RACE_VIDEO_UPLOAD_FAIL'
    static readonly RACE_VIDEO_UPLOAD_HOLD:'BP_EM_RACE_VIDEO_UPLOAD_HOLD'

    static readonly SEARCH_RACER:'BP_EM_SEARCH_RACER'
    static readonly OPERATOR_TEXT:'BP_EM_OPERATOR_TEXT'
    
    static readonly DRAG_DROP:'BP_EM_DRAG_DROP'
    static readonly EDIT_EVENT:'BP_EM_EDIT_EVENT'
    static readonly ERROR_LARGE_IMAGE:'BP_EM_ERR_LARGEIMG'
    static readonly ERROR_SMALL_IMAGE:'BP_EM_ERR_SMALLIMG'
    static readonly PARTICPANT_ADD_EDIT_DOWN:'BP_EM_PARTICIPANT_AED'
    static readonly ADD_EVENT_INFO:'BP_ADD_EVENT_INFO'
    static readonly ALL:'BP_EM_All'
    static readonly ADD_PARTICIPANT:'BP_EM_ADD_PARTICIPANT'
    static readonly ADD_PARTICIPANTS:'BP_EM_ADD_PARTICIPANTS'

    static readonly DOWNLOAD_PART_QR:'BP_EM_DOWNLOAD_PART_QR'
    static readonly DOWNLOAD_PART_QR_CODES:'BP_EM_DOWNLOAD_PART_QR_CODES'
    static readonly ENTER_EVENT_HASHTAG:'BP_EM__ENTER_EVENT_HASHTAG'
    static readonly BP_EM_EVENT_ESVU:'BP_EM_EVENT_ESVU'
    static readonly CHANGE_EX_NAME:'BP_EM_CHANGE_EX_NAME'
    static readonly ENTER_SHORT_URL:'BP_EM_ENTER_SHORT_URL'

    static readonly EXERCISE_FLEADERBOARD:'BP_EM_EXERCISE_FLEADERBOARD'
    static readonly EXERCISE_LEADERBOARD_DETAILS:'BP_EM_EXERCISE_LEADERBOARD_DETAILS'
    static readonly CIRCUIT_LAYOUT_DETAILS:'BP_EM_CIRCUIT_LAYOUT_DETAILS'
    static readonly LEADERBOARD_LINKS:'BP_EM_LEADERBOARD_LINKS'
    static readonly LIVE_LEADRBOARD:'BP_EM_LIVE_LEADRBOARD'
    static readonly MOBILE_RANKING:'BP_EM_MOBILE_RANKING'
    static readonly SEARCH_CIRCUIT:'BP_EM_SEARCH_CIRCUIT'
    static readonly SEARCH_HERE:'BP_EM_SEARCH_HERE'

    static readonly UPDATE_SCORE:'BP_EM_UPDATE_SCORE'
    static readonly SCORE:'BP_EM_SCORE'
    
    static readonly RACES_JUST_NOW:'BP_EM_RACES_JUST_NOW'
    static readonly RACES_MIN_AGO:'BP_EM_RACES_MIN_AGO'
    static readonly RACES_YESTERDAY:'BP_EM_RACES_YESTERDAY'
    static readonly REMOVE_EXERCISE:'BP_EM_REMOVE_EXERCISE'
    static readonly SEARCH_PART_NAME:'BP_EM_SEARCH_PART_NAME'
    static readonly BEST_TIME:'BP_EM_BEST_TIME'

    static readonly CONSISTANCY:'BP_EM_CONSISTANCY'
    static readonly EFFICIENCY:'BP_EM_EFFICIENCY'
    static readonly EXERCISE_NOT_DELETED:'BP_EM_EXERCISE_NOT_DELETED'
    static readonly LIVE_EVENTS:'BP_EM_LIVE_EVENTS'
    static readonly BP_EM_PARTICIPANT:'BP_EM_PARTICIPANT'

    static readonly PARTICIPANTS_ENTER_EMAIL:'BP_EM_PARTICIPANTS_ENTER_EMAIL'
    static readonly PARTICIPANTS_ENTER_FNAME:'BP_EM_PARTICIPANTS_ENTER_FNAME'
    static readonly PARTICIPANTS_ENTER_LNAME:'BP_EM_PARTICIPANTS_ENTER_LNAME'
    static readonly PARTICIPANTS_FIRST_NAME:'BP_EM_PARTICIPANTS_FIRST_NAME'
    static readonly PARTICIPANTS_LAST_NAME:'BP_EM_PARTICIPANTS_LAST_NAME'
    static readonly PARTICIPANTS_NOT_AVAILABLE:'BP_EM_PARTICIPANTS_NOT_AVAILABLE'
    static readonly PARTICIPANTS_REFRESH:'BP_EM_PARTICIPANTS_REFRESH'
    static readonly PARTICIPANTS_SCREEN_SUBTITLE:'BP_EM_PARTICIPANTS_SCREEN_SUBTITLE'
    static readonly PARTICIPANTS_SEARCH_PLACEHOLDER:'BP_EM_PARTICIPANTS_SEARCH_PLACEHOLDER'
    static readonly PARTICIPANTS_SLNO:'BP_EM_PARTICIPANTS_SLNO'

    static readonly PARTICIPANT_GROUPS:'BP_EM_PARTICIPANT_GROUPS'
    static readonly UPLOAD_EXCEL:'BP_EM_UPLOAD_EXCEL'
    static readonly ACTIONS:'BP_EM_ACTIONS'
    static readonly DELETE_PARTICIPANTS:'BP_EM_DELETE_PARTICIPANTS'
    static readonly DOWNLOAD_PARTICIPANTS:'BP_EM_DOWNLOAD_PARTICIPANTS'
    static readonly LANGUAGE:'BP_EM_LANGUAGE'
    static readonly LAST_UPDATED:'BP_EM_LAST_UPDATED'
    static readonly LOCAL_LANGUAGE:'BP_EM_LOCAL_LANGUAGE'

    static readonly NO_PARTICIPANTS:'BP_EM_NO_PARTICIPANTS'
    static readonly SEARCH_RESULTS:'BP_EM_SEARCH_RESULTS'
    static readonly PARTICIPANTS:'BP_EM_PARTICIPANTS'
    static readonly BROWSE_EVENT:'BP_EM_BROWSE_EVENT'
   
    static readonly NAME:'BP_EM_NAME'
    static readonly ADD_PENALTY:'BP_EM_ADD_PENALTY'
    static readonly CHANGE_IMAGE:'BP_EM_CHANGE_IMAGE'
    static readonly END_DATE:'BP_EM_END_DATE'
    static readonly START_DATE:'BP_EM_START_DATE'


    static readonly COVER_IMAGE:'BP_EM_COVER_IMAGE'
    static readonly DRAG_DROP_CIRCUIT_IMAGE:'BP_EM_DRAG_DROP_CIRCUIT_IMAGE'
    static readonly UPLOAD_EVENT_LOGO:'BP_EM_UPLOAD_EVENT_LOGO'
    static readonly ABOUT_EVENT:'BP_EM_ABOUT_EVENT'

    static readonly ADD_FIRST_EXERCISE:'BP_EM_ADD_FIRST_EXERCISE'
    static readonly CREATE_GROUP:'BP_EM_CREATE_GROUP'
    static readonly CROP_EVENT_IMAGE:'BP_EM_CROP_EVENT_IMAGE'
    static readonly DELETE_EVENT:'BP_EM_DELETE_EVENT'
    static readonly ADMIN_QR:'BP_EM_ADMIN_QR'
    static readonly DOWNLOAD_QR_CODES:'BP_EM_DOWNLOAD_QR_CODES'

    static readonly EDIT_PENALTY:'BP_EM_EDIT_PENALTY'
    static readonly EDIT_PENALTY_FOR:'BP_EM_EDIT_PENALTY_FOR'
    static readonly EVENT_EXERCISE:'BP_EM_EVENT_EXERCISE'
    static readonly GENERATING_ADMIN_QR:'BP_EM_GENERATING_ADMIN_QR'
    static readonly EXERCISE_LEADERBOARD:'BP_EM_SET_EXERCISE_LEADERBOARD'
    static readonly EXERCISE:'BP_EM_EXERCISE'
    static readonly FINAL_TIME:'BP_EM_FINAL_TIME'
    static readonly GENERATE_QR:'BP_EM_GENERATE_QR'

    static readonly VIEW_BEST_RACES:'BP_EM_VIEW_BEST_RACES'
    static readonly UPLOAD_IMAGE:'BP_EM_UPLOAD_IMAGE'
    static readonly IMAGE_LARGE:'BP_EM_IMG_LARGE'
    static readonly STAY_ON_PAGE:'BP_EM_STAY_ON_PAGE'
    static readonly CHANGES_WONT_SAVE:'BP_EM_CHANGES_WONT_SAVE'
    static readonly LEAVE_PAGE:'BP_EM_LEAVE_PAGE'
    static readonly UPLOAD_FAILED:'BP_EM_UPLOAD_FAILED'
    static readonly TRY_AGAIN:'BP_EM_TRY_AGAIN'
    static readonly WANT_TO_LEAVE_PAGE:'BP_EM_WANT_TO_LEAVE_PAGE'

    static readonly LIVE_RACES:'BP_EM_LIVE_RACES'
    
    static readonly NO_PARTICPANTS:'BP_EM_NO_PARTICPANTS'
    static readonly PENALTY_ADDED:'BP_EM_PENALTY_ADDED'
    static readonly ADD_PENALTY_FOR:'BP_EM_ADD_PENALTY_FOR'
    static readonly PRINT:'BP_EM_PRINT'

    static readonly RACES_UPDATED:'BP_EM_RACES_UPDATED'
    static readonly CHECK_NEW_RACES:'BP_EM_CHECK_NEW_RACES'
    static readonly SEARCH_EVENTS:'BP_EM_SEARCH_EVENTS'
    
    static readonly EVENT_LABELS = {
        EVENT_LOGO:'BP_EM_EVENT_LOGO',
        EVENT_NAME:'BP_EM_EVENT_NAME'
    }

    static readonly DROP_DOWN_LABELS = {
        NAME_AZ:'BP_EM_NAME_AZ',
        NEW_OLD:'BP_EM_NEW_OLD',
        OLD_NEW:'BP_EM_OLD_NEW',
        BP_EM_NAME_AZ:'BP_EM_NAME_AZ',
        EVENT_TYPES:'BP_EM_EVENT_TYPES',
        SORT_BY:'BP_EM_SORT_BY'
    }

    static readonly BUTTON_LABELS={
         MANAGE:'BP_EM_MANAGE_BTN_LBL',
         ADD_SCORE: 'BP_EM_ADD_SCORE',
         GROUP:'BP_EM_GROUP_BTN_LBL',
         ADD:'BP_EM_ADD_BTN_LBL',
         SUBMIT:'BP_EM_SUBMIT_BTN_LBL',
         UPLOAD:'BP_EM_UPLOAD_BTN_LBL',
         MANAGE_EVENT:'BP_EM_MANAGE_EVENT',
         MANAGE_EVENT_RELATED_DETAILS:'BP_EM_MANAGE_EVENT_RELATED_DETAILS',
         CREATE_EVENT:'BP_EM_CREATE_EVENT',
         CREATE_NEW_EVENT:'BP_EM_CREATE_NEW_EVENT',
         MANAGE_PARTICIPANTS:'BP_EM_MANAGE_PARTICIPANTS',
         CREATE:'BP_EM_CREATE'
    }

    static readonly ERROR_MESSAGES={
        PAST_EVENT_MODIFY:'BP_EM_PAST_EVENT_MODIFY',
        DELERE_EVENT_RACES:'BP_EM_DELERE_EVENT_RACES',
        EXERCISE_EXIST:'BP_EM_EXERCISE_EXIST',
        PAST_EXERCISE_UPDATE:'BP_EM_PAST_EXERCISE_UPDATE',
        PARTICIPANT_EXIST:'BP_EM_ERROR_PARTICIPANT_EXIST',
        DELETE_PARTICIPANT:'BP_EM_ERROR_DELETE_PARTICIPANT',
        AUTHORIZATION:'BP_EM_ERROR_AUTHORIZATION',
        EMAIL_ALREADY_EXISTS:'BP_EM_EMAIL_ALREADY_EXISTS',
        RACE_FOUND:'BP_EM_ERROR_RACE_FOUND',
        SCORE_MISMATCH:'BP_EM_ERROR_SCORE_MISMATCH'
    }

    static readonly ALERT_POPUP_TITLES={
        CONFIRM_DELETE_EVENT_TITLE:'BP_EM_CONFIRM_DELETE_EVENT_TITLE',
        CONFIRM_DELETE_EXERCISE_TITLE:'BP_EM_CONFIRM_DELETE_EXERCISE_TITLE',
        CONFIRM_DELETE_RACE_TITLE: 'BP_EM_CONFIRM_DELETE'
    }
    
    static readonly ALERT_POPUP_MESSAGES={
        DELETE_EVENT_CONFIRM_MSG: 'BP_EM_DLT_EVENT_CONFIRM_MSG',
        DELETE_EXERCISE_CONFIRM_MSG: "BP_EM_DLT_EXERCISE_CONFIRM_MSG",
        DELETE_RACE_CONFIRM_MSG: 'BP_EM_DLT_RACE_CONFIRM_MSG'
    }
}